// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTabs_wrapper__27reY","tab_item":"PageTabs_tab_item__3QLnC"};